
import { defineComponent, ref } from 'vue'
import Button from '@/components/elements/Button.vue'

export default defineComponent({
  name: 'CbtAccordion',
  components: {
    Button
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    number: {
      type: Number
    },
    isTop: {
      type: Boolean,
      default: false
    }
  },

  setup() {
    const numberToKanji = (number: number) => {
      const kanji = ['一', '二', '三', '四', '五']
      return kanji[number - 1]
    }

    return {
      numberToKanji
    }
  }
})
